import React from "react";
import {
  CloseButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiSearch } from "@react-icons/all-files/fi/FiSearch";
import { bg } from "date-fns/locale";

type TutorialsSearchInputProps = {
  value: string;
  clear: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function TutorialsSearchInput({
  value,
  onChange,
  clear,
}: TutorialsSearchInputProps) {
  const focusBorderColor = useColorModeValue("blue.500", "blue.300");
  const bg = useColorModeValue("silver.400", "black.200");
  const hoverBg = useColorModeValue("silver.300", "black.300");

  return (
    <InputGroup variant="filled" size="lg" zIndex={0}>
      <Input
        bg={bg}
        _hover={{ bg: hoverBg }}
        placeholder="Search Odyssey's catalog"
        _focus={{
          bg: hoverBg,
          borderColor: focusBorderColor,
          _placeholder: {
            color: "inherit",
          },
        }}
        value={value}
        onChange={onChange}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            clear();
          }
        }}
      />
      <InputLeftElement>
        <FiSearch />
      </InputLeftElement>
      {value && (
        <InputRightElement>
          <CloseButton onClick={clear} />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
